module.exports = __webpack_public_path__ + "static/media/S4N3-2.7cddf652.svg";